import { render, staticRenderFns } from "./producer-add.vue?vue&type=template&id=1791f032&scoped=true"
import script from "./producer-add.vue?vue&type=script&lang=js"
export * from "./producer-add.vue?vue&type=script&lang=js"
import style0 from "./producer-add.vue?vue&type=style&index=0&id=1791f032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791f032",
  null
  
)

export default component.exports